import Icon from 'components/Icon'
import React, { useContext, useEffect, useState } from 'react'
import { RiDeleteBin5Fill } from "react-icons/ri";
import { TiPin } from "react-icons/ti";
import { FaShare } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import AddPromptModal from 'components/PromptModal';
import { useUsersContext } from 'context/usersContext';
import { PromptsContext } from 'context/promptsContext';
import axios from "axios";
import env from 'config';
import { useHistory } from "react-router-dom";
import DeleteChatModal from 'components/DeleteChatModal';
import EditPromptModal from 'components/PromptModal';
import SharePromptModal from 'components/SharePromptModal';
import { FaPlus } from "react-icons/fa6";
import TaskSchedualsComp from './TaskSchedualsComp';
import toast from 'react-hot-toast';

const TaskContainer = ({ LoadTaskonchat, setShowMainBody, assistantData, toggleSidebar, asistantSelected }) => {
    const { promptsData, getPrompts, favouritesData, getFavourites } = useContext(PromptsContext);
    const { SSO, showToast, getLocationUsers, locationUsers, handleRefreshData } = useUsersContext();
    const history = useHistory();

    function getClientUTCOffset() {
        const offset = new Date().getTimezoneOffset();
        const sign = offset > 0 ? "-" : "+";
        const abs = Math.abs(offset);
        const hours = String(Math.floor(abs / 60)).padStart(2, "0");
        const mins = String(abs % 60).padStart(2, "0");
        return `${sign}${hours}:${mins}`;
    }
    const utcOffset = getClientUTCOffset()

    const [isOpenAddPromptModal, setIsAddPromptModal] = useState(false);
    const [selectedCategoryId,] = useState();
    const [askToDeleteModal, setAskToDeleteModal] = useState(false);
    const [askToDeleteScheduledPrompt, setAskToDeleteScheduledPrompt] = useState(false);
    const [selectedContact, setSelectedContact] = useState(false);
    const [isEditPrompt, setIsEditPrompt] = useState();
    const [isEditPromptScheduled, setIsEditPromptScheduled] = useState();
    const [isOpenEditPromptModal, setIsOpenEditPromptModal] = useState(false);
    const [isOpenEditPromptModalScheduled, setIsOpenEditPromptModalScheduled] = useState(false);
    const [askToShareModal, setAskToShareModal] = useState(false);
    const [, setMoreOption] = useState(false)
    const [, setThreeDotOptions] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [scheduledProm, setScheduledProm] = useState([]);

    const BASE_URL = `${env.API_URL}/v1`;

    const favPromptIds = Array.isArray(favouritesData) ? favouritesData.map(fav => fav.prompt_id) : [];
    const favPrompts = Array.isArray(promptsData?.prompt) ? promptsData.prompt.filter(prompt => favPromptIds.includes(prompt._id)) : [];


    const getScheduled = async () => {
        const response = await axios.get(`${BASE_URL}/prompts/scheduled?userId=${SSO?.userUUID}&location_id=${SSO?.id}&agency_id=${SSO?.agency_id}`);
        if (response) {
            setScheduledProm(response?.data?.data || []);
        }
    };

    const addPromptHandle = () => {
        setIsAddPromptModal(true);
    }

    const justCloseIt = () => {
        setIsAddPromptModal(false);
        setAskToDeleteModal(false);
        setSelectedContact(false);
        setIsOpenEditPromptModal(false);
        setIsOpenEditPromptModalScheduled(false);
        setAskToShareModal(false);
        setMoreOption(false)
        setThreeDotOptions(false);
        setAskToDeleteScheduledPrompt(false);
        getPrompts();
        getScheduled();
        setIsEditPromptScheduled(null)
        setIsEditPrompt(null)
    }

    const limitWords = (text, wordLimit) => {
        if (!text) return ""; // Return empty if no text
        const words = text.split(' ');
        return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
    };

    const removeFromFav = async (e, prompt) => {

        const favoriteId = favouritesData?.find(favorite => favorite.prompt_id === prompt?._id)?._id;
        const response = await axios.get(`${BASE_URL}/chat/remove/favourite?chatId=${favoriteId}&user_id=${SSO?.userUUID}&location_id=${SSO?.id}`);
        if (response) {
            getFavourites();
            handleRefreshData(); justCloseIt();
        }
    }

    const handleFavourite = async (e, prompt) => {

        const response = await axios.get(`${BASE_URL}/chat/add/favourite?prompt_id=${prompt?._id}&user_id=${SSO?.userUUID}&location_id=${SSO?.id}`);
        if (response) {
            getFavourites();
            handleRefreshData(); justCloseIt();
        }
    }

    const askToDelete = async (e, contact) => {
        setSelectedContact(contact);
        setAskToDeleteModal(true);
    }

    const askToDeleteScheduled = async (e, contact) => {
        setSelectedContact(contact);
        setAskToDeleteScheduledPrompt(true);
    }

    const handleDeleteClick = async () => {
        const response = await axios.delete(`${BASE_URL}/chat/promptDelete?_id=${selectedContact._id}`);
        if (response) {
            // setUsers((users) => users.filter((user) => user.id !== selectedContact?.id));
            const redirectUrl = `/`;
            history.push(redirectUrl);
            justCloseIt();
            getPrompts();
        } else {
            showToast('Something went wrong!')
        }
    };

    const handleDeleteScheduledPrompt = async () => {
        const response = await axios.delete(`${BASE_URL}/prompts/delete/scheduled?_id=${selectedContact._id}`);
        if (response) {
            const redirectUrl = `/`;
            history.push(redirectUrl);
            justCloseIt();
            getPrompts();
        } else {
            showToast('Something went wrong!')
        }
    };

    const handleEditPrompt = (e, prompt) => {
        if (prompt?.scheduleTime === undefined) {
            setIsEditPrompt(prompt)
            setIsOpenEditPromptModal(true)
        } else {
            setIsEditPromptScheduled(prompt)
            setIsOpenEditPromptModalScheduled(true)
        }
    }

    const askToShare = async (e, contact) => {
        setSelectedContact(contact);
        setAskToShareModal(true);
    }

    // Function to highlight search term in text
    const highlightSearch = (text) => {
        if (!searchTerm || !text) return text;
        const search = searchTerm.trim();
        if (!search) return text;
        // Escape special regex characters in search
        const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escaped})`, 'gi');
        return text.split(regex).map((part, i) =>
            regex.test(part) ? <b key={i} style={{ background: '#ffe066' }}>{part}</b> : part
        );
    };



    useEffect(() => {
        getScheduled();
    }, [SSO]); // eslint-disable-line react-hooks/exhaustive-deps

    const closeNav = () => {
        setShowMainBody('chat');
    }

    const handleSendToChat = async (title, value, output, channel, integration_id) => {
        const response = await axios.post(
            `${BASE_URL}/prompts/messaging`,
            {
                profile_id: SSO?.id,
                user_id: SSO?.UserInfo?.userId,
                provider_id: output,
                message: value,
                channel_id: channel,
                ...(integration_id != null ? { integration_id } : {}),
            },
            {
                timeout: 100000,
            }
        );

        if (response?.data?.data?.message) {
            toast.success(response?.data?.data?.message);
            console.log("Messaging Response:", response?.data?.data?.message);
        }
    };

    const handleCombineFunction = (title, value, output, channel, integration_id) => {
        if (output === 'chatUi') {
            LoadTaskonchat(title, value)
            closeNav();
            handleRefreshData();
        }

        if (output === 'slack') {
            handleSendToChat(title, value, output, channel, integration_id);
        }

    }

    // Determine if there are any tasks to search
    const hasTasks = (
        (Array.isArray(promptsData?.prompt) && promptsData.prompt.length > 0) ||
        (Array.isArray(scheduledProm) && scheduledProm.length > 0)
    );

    return (
        <div className="newUI_outer_container">
            <div className="newUI_container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                    <div className="newUI_title_task">Tasks</div>

                    <button onClick={addPromptHandle} style={{ color: 'white' }} className='newUI_NewTaskButton'>
                        <FaPlus />
                        <span style={{ marginLeft: '10px' }}>New Task</span>
                    </button>
                </div>

                {hasTasks && (
                    <div className="newUI_search_bar_section">
                        <div className='newUI_search_input_box'>
                            <div className="newUI_search_icon">
                                <Icon
                                    id="v3_search"
                                />
                            </div>

                            <input type="text" placeholder="Search your tasks" className="newUI_search_input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                        </div>
                    </div>
                )}

                {Array.isArray(promptsData?.prompt) && promptsData.prompt
                    .filter(item => !selectedCategoryId?._id || item.category === selectedCategoryId?._id)
                    .filter(item => favPrompts.some(favItem => favItem._id === item._id))
                    .filter(item => {
                        const search = searchTerm.trim().toLowerCase();
                        if (!search) return true;
                        return (
                            (item.title && item.title.toLowerCase().includes(search)) ||
                            (item.prompt_value && item.prompt_value.toLowerCase().includes(search))
                        );
                    })
                    .map((item, index) => (
                        <div key={index} className="newUI_result_card">
                            <div>
                                <h3>{highlightSearch(item?.title)}</h3>
                                <p>{highlightSearch(limitWords(item?.prompt_value, 18))}</p>
                            </div>

                            <span className="three_dots" style={{ padding: "5px" }} onClick={(e) => { e.stopPropagation(); removeFromFav(e, item); }}>
                                <Icon id="pintask" />
                            </span>
                        </div>))}

                {[
                    ...(Array.isArray(scheduledProm) ? scheduledProm : []),
                ]
                    .filter(item => !selectedCategoryId?._id || item.category === selectedCategoryId?._id)
                    .filter(item => !favPrompts.some(favItem => favItem._id === item._id))
                    .filter(item => {
                        const search = searchTerm.trim().toLowerCase();
                        if (!search) return true;
                        return (
                            (item.title && item.title.toLowerCase().includes(search)) ||
                            (item.prompt_value && item.prompt_value.toLowerCase().includes(search))
                        );
                    })
                    .map((item, index) => (
                        <div onClick={() => handleCombineFunction(item.title, item.prompt_value, item.output, item.channel, item?.integration_id)} key={index} className="newUI_result_card">
                            <div>
                                <h3>{highlightSearch(item?.title)}</h3>
                                <p>{highlightSearch(limitWords(item?.prompt_value, 18))}</p>
                            </div>
                            {/* <span className="newUI_meta">Last message 2 hours ago</span> */}
                            <TaskSchedualsComp taskData={item} />
                            <div className='newUI_task_actions'>
                                <span onClick={(e) => { e.stopPropagation(); handleFavourite(e, item) }}>
                                    <TiPin />
                                </span>

                                {item?.type !== 'super-admin' && item?.type !== 'agency' && item?.type !== 'agency-admin' && (

                                    <div className='newUI_task_actions1'>
                                        <span onClick={(e) => { e.stopPropagation(); askToDeleteScheduled(e, item) }}>
                                            <RiDeleteBin5Fill />
                                        </span>

                                        <span onClick={(e) => { e.stopPropagation(); askToShare(e, item) }}>
                                            <FaShare />
                                        </span>

                                        <span onClick={(e) => { e.stopPropagation(); handleEditPrompt(e, item) }}>
                                            <MdEdit />
                                        </span>
                                    </div>
                                )}

                            </div>



                        </div>))}

                {[
                    ...(Array.isArray(promptsData?.prompt) ? promptsData.prompt : []),
                ]
                    .filter(item => !selectedCategoryId?._id || item.category === selectedCategoryId?._id)
                    .filter(item => !favPrompts.some(favItem => favItem._id === item._id))
                    .filter(item => {
                        const search = searchTerm.trim().toLowerCase();
                        if (!search) return true;
                        return (
                            (item.title && item.title.toLowerCase().includes(search)) ||
                            (item.prompt_value && item.prompt_value.toLowerCase().includes(search))
                        );
                    })
                    .map((item, index) => (
                        <div onClick={() => handleCombineFunction(item.title, item.prompt_value, item.output, item.channel, item?.integration_id)} key={index} className="newUI_result_card">
                            <div>
                                <h3>{highlightSearch(item?.title)}</h3>
                                <p>{highlightSearch(limitWords(item?.prompt_value, 18))}</p>
                            </div>
                            {/* <span className="newUI_meta">Last message 2 hours ago</span> */}

                            <div className='newUI_task_actions'>
                                <span onClick={(e) => { e.stopPropagation(); handleFavourite(e, item) }}>
                                    <TiPin />
                                </span>

                                {item?.type !== 'super-admin' && item?.type !== 'agency' && item?.type !== 'agency-admin' && (

                                    <div className='newUI_task_actions1'>
                                        <span onClick={(e) => { e.stopPropagation(); askToDelete(e, item) }}>
                                            <RiDeleteBin5Fill />
                                        </span>

                                        <span onClick={(e) => { e.stopPropagation(); askToShare(e, item) }}>
                                            <FaShare />
                                        </span>

                                        <span onClick={(e) => { e.stopPropagation(); handleEditPrompt(e, item) }}>
                                            <MdEdit />
                                        </span>
                                    </div>
                                )}

                            </div>

                        </div>))}
            </div>

            <AddPromptModal
                assistantData={assistantData}
                isModalOpen={isOpenAddPromptModal}
                categories={promptsData?.prompt_category?.filter(obj => obj.type !== 'super-admin')}
                subCategories={promptsData?.prompt_sub_category?.filter(obj => obj.type !== 'super-admin')}
                justCloseIt={justCloseIt}
                getUpdatePromptsData={getPrompts}
                asistantSelected={asistantSelected}
                utcOffset={utcOffset}
            />

            <DeleteChatModal
                modelType="Task"
                isModalOpen={askToDeleteModal}
                contact={selectedContact}
                yesDelete={handleDeleteClick}
                justCloseIt={justCloseIt}
                type="prompt"
            />

            <DeleteChatModal
                modelType="Task"
                isModalOpen={askToDeleteScheduledPrompt}
                contact={selectedContact}
                yesDelete={handleDeleteScheduledPrompt}
                justCloseIt={justCloseIt}
                type="prompt"
            />

            {
                isEditPrompt && (
                    <EditPromptModal
                        isModalOpen={isOpenEditPromptModal}
                        categories={promptsData?.prompt_category?.filter(obj => obj.type !== 'super-admin')}
                        subCategories={promptsData?.prompt_sub_category?.filter(obj => obj.type !== 'super-admin')}
                        justCloseIt={justCloseIt}
                        getUpdatePromptsData={getPrompts}
                        editadata={isEditPrompt}
                        setIsEditPrompt={setIsEditPrompt}
                        utcOffset={utcOffset}
                    />
                )
            }

            {
                isEditPromptScheduled && (
                    <EditPromptModal
                        isModalOpen={isOpenEditPromptModalScheduled}
                        categories={scheduledProm?.prompt_category?.filter(obj => obj.type !== 'super-admin')}
                        subCategories={scheduledProm?.prompt_sub_category?.filter(obj => obj.type !== 'super-admin')}
                        justCloseIt={justCloseIt}
                        getUpdatePromptsData={getScheduled}
                        editadata={isEditPromptScheduled}
                        setIsEditPrompt={setIsEditPromptScheduled}
                        utcOffset={utcOffset}
                    />
                )
            }

            <SharePromptModal
                isModalOpen={askToShareModal}
                contact={selectedContact}
                justCloseIt={justCloseIt}
                getLocationUsers={getLocationUsers}
                locationUsers={locationUsers}
            />
        </div>
    )
}

export default TaskContainer
